// Frontend mirror of the conversations service's `EvalRunStatus`
// (conversations_types.enums). Lifecycle: pending → running → succeeded | failed.
export const EvalRunStatus = {
  PENDING: "pending",
  RUNNING: "running",
  SUCCEEDED: "succeeded",
  FAILED: "failed",
} as const;
export type EvalRunStatus = (typeof EvalRunStatus)[keyof typeof EvalRunStatus];

// succeeded/failed are terminal and never change again; pending/running are
// still in flight. A run that reaches a terminal status stops polling.
export const EVAL_RUN_TERMINAL_STATUSES: ReadonlySet<string> = new Set([
  EvalRunStatus.SUCCEEDED,
  EvalRunStatus.FAILED,
]);

// The subset of the eval-run record the panel reads. The launch UI is
// status-only, so the report/judge blobs are deliberately not modelled here.
export interface EvalRunResponse {
  id: string;
  status: string;
  tags: string[];
  started_at: string;
  completed_at: string | null;
  model_name: string | null;
}

// A run's human-facing label: its case-selector tags, or a short id fallback
// when it targets every case. Shared by the TOC row, the list, and the detail
// header switcher so all three read the same.
export function evalRunLabel(tags: string[], runId: string): string {
  if (tags.length > 0) {
    return tags.join(", ");
  }
  return runId.length > 8 ? `${runId.slice(0, 8)}…` : runId;
}
